import { translateText, useFormController } from '@dreryk/react-common';
import {
   EmailAddressInput,
   Notification,
   NotificationSize,
   NotificationType,
   PhoneNumberInput,
   StyledFlex,
} from '@dreryk/react-components';

import { translationKeys } from '../translations';
import { PatientContactData } from '../types';

import {
   PatientContactDataUpdateFormBean,
   PatientContactDataUpdateFormSubmitHandler,
} from './PatientContactDataUpdateForm.types';

const t = translationKeys;

type PatientContactDataUpdateFormRenderProps = {
   handleSubmit: PatientContactDataUpdateFormSubmitHandler;
};

type PatientContactDataUpdateFormProps = Readonly<{
   children: (renderProps: PatientContactDataUpdateFormRenderProps) => JSX.Element;
   patientContactData: PatientContactData;
   phoneNumberRequired?: boolean;
   emailAddressRequired?: boolean;
}>;

export const PatientContactDataUpdateForm = (props: PatientContactDataUpdateFormProps): JSX.Element => {
   const { register, handleSubmit } = useFormController<PatientContactDataUpdateFormBean>({
      emailAddress: props.patientContactData.emailAddress ?? null,
      phoneNumber: props.patientContactData.phoneNumber ?? null,
   });

   return (
      <StyledFlex as={'form'} gap={18} direction={'column'}>
         <EmailAddressInput
            controller={register('emailAddress', { required: props.emailAddressRequired })}
            testId={'emailAddress'}
            label={t.email}
            placeholder={translateText(t.fillInPatientEmail)}
         />

         <StyledFlex gap={8} direction={'column'}>
            <PhoneNumberInput
               controller={register('phoneNumber', { required: props.phoneNumberRequired })}
               testId={'phoneNumber'}
               label={t.phoneNumber}
            />

            <Notification
               testId={'additionalInformation'}
               type={NotificationType.INFO}
               label={t.additionalInformation}
               size={NotificationSize.SMALLER}
            />
         </StyledFlex>

         {props.children({ handleSubmit: handleSubmit })}
      </StyledFlex>
   );
};
